/* eslint-disable */

import angular from 'angular';
import * as R from 'ramda';
import moment from 'moment';
import pmDataService from '../data/pm.data.service';
import orgDataService from '../data/org.data.service';
import ISharedModelService from './ISharedModel.service';
import transformations from './pm.sharedModel.transformations';

/* eslint-disable no-unused-vars */
let _pmDataService;
let _orgDataService;
let _$q;
let _utilityService;

/* eslint-enable no-unused-vars */

class pmSharedModelService extends ISharedModelService {
  constructor(
    $q,
    pmDataService, // eslint-disable-line no-shadow
    orgDataService, // eslint-disable-line no-shadow
    utilityService,
  ) {
    super('pm');
    _$q = $q;
    _pmDataService = pmDataService;
    _orgDataService = orgDataService;
    _utilityService = utilityService;

    this.changedSections = {};
    this.masterDocumentSections = {};
    this.flattenedActiveDocumentSections = {};
    this.policyDocumentEndNotes = {};
    this.masterEndNotes = {};

    console.log('app.services.pmSharedModelService created');
  }

  // #################################################################################################
  // DOCUMENT

  allowNewAssessment() {
    return _pmDataService
      .allowNewAssessment()
      .then(response => (response.data && response.data.result) || false)
      .catch(() => false);
  }

  initPolicyManagement() {
    return _pmDataService.initPolicyManagement().then(({ data }) => {
      const {
        customerId,
        variables,
        policyDocumentEndNotes,
        masterEndNotes,
        masterDocumentSections,
        changedSections,
        changedEndNotes,
      } = data;
      const stg = R.defaultTo('');
      const ef = item => R.isEmpty(stg(item.value));
      let emptyVariables = R.filter(ef, variables);

      // Don't treat the Succession Planning Names as Empty Variables
      const pi = emptyVariables.findIndex(item => item.tag === 'Primary_IT_Resource');
      if (pi >= 0) {
        emptyVariables.splice(pi, 1);
      }

      const si = emptyVariables.findIndex(item => item.tag === 'Secondary_IT_Resource');
      if (si >= 0) {
        emptyVariables.splice(si, 1);
      }

      const ti = emptyVariables.findIndex(item => item.tag === 'Tertiary_IT_Resource');
      if (ti >= 0) {
        emptyVariables.splice(ti, 1);
      }

      // Don't treat the Tertiary ISO Resources as Empty Variables
      const isoti = emptyVariables.findIndex(item => item.tag === 'Tertiary_ISO_Resource');
      if (isoti >= 0) {
        emptyVariables.splice(isoti, 1);
      }

      this.generateTokenizedTextAndBreadcrumbs(data.changedSections);

      const documents = this._extractDocuments(data.documents);
      return {
        customerId,
        documents,
        emptyVariables,
        variables,
        policyDocumentEndNotes,
        masterEndNotes,
        masterDocumentSections,
        changedSections,
        changedEndNotes,
      };
    });
  }

  generateTokenizedTextAndBreadcrumbs(changedSections) {
    if (changedSections !== null) {
      if (changedSections.addedMasterSectionIds != null) {
        changedSections.addedMasterSectionIds.forEach(element => {
          element.breadcrumb = this._breadcrumb(element.breadcrumbs);
          element.tokenizedBody = this.replaceTokens(element.valueCurrent || '');
          element.tokenizedNewBody = this.replaceTokens(element.valueTo || '');
        });
      }
      if (changedSections.deletedSectionIds != null) {
        changedSections.deletedSectionIds.forEach(element => {
          element.breadcrumb = this._breadcrumb(element.breadcrumbs);
          element.tokenizedBody = this.replaceTokens(element.valueCurrent || '');
          element.tokenizedNewBody = this.replaceTokens(element.valueTo || '');
        });
      }
      if (changedSections.updatedSectionIds != null) {
        changedSections.updatedSectionIds.forEach(element => {
          element.breadcrumb = this._breadcrumb(element.breadcrumbs);
          element.tokenizedBody = this.replaceTokens(element.valueCurrent || '');
          element.tokenizedNewBody = this.replaceTokens(element.valueTo || '');
        });
      }
    }
  }

  getCompareToMasterSection(policyDocumentId) {
    return _pmDataService.getCompareToMasterSection(policyDocumentId).then(({ data }) => {
      const changeArrays = data;

      const { deletedSectionIds, updatedSectionIds } = changeArrays;

      let changeData;
      if (deletedSectionIds && deletedSectionIds.length > 0) {
        changeData = deletedSectionIds[0];
      } else if (updatedSectionIds && updatedSectionIds.length > 0) {
        changeData = updatedSectionIds[0];
      } else {
        alerts.error('Section could not be synced.');
        return;
      }

      if (changeData.changedSections != null) {
        if (changeData.changedSections.addedMasterSectionIds != null) {
          changeData.changedSections.addedMasterSectionIds.forEach(element => {
            element.breadcrumb = this._breadcrumb(element.breadcrumbs);
          });
        }
        if (changeData.changedSections.deletedSectionIds != null) {
          changeData.changedSections.deletedSectionIds.forEach(element => {
            element.breadcrumb = this._breadcrumb(element.breadcrumbs);
          });
        }
        if (changeData.changedSections.updatedSectionIds != null) {
          changeData.changedSections.updatedSectionIds.forEach(element => {
            element.breadcrumb = this._breadcrumb(element.breadcrumbs);
          });
        }
      }

      const changes = {
        ...changeData,
        changeArrays,
        tokenizedCurrent: replaceTokens(changeData.valueCurrent),
        tokenizedTo: replaceTokens(changeData.valueTo),
      };

      return changes;
    });
  }

  setupBreadcrumbs() {
    if (this.changedSections != null) {
      if (this.changedSections != null) {
        if (this.changedSections.addedMasterSectionIds != null) {
          this.changedSections.addedMasterSectionIds.forEach(element => {
            element.breadcrumb = this._breadcrumb(element.breadcrumbs);
          });
        }
        if (this.changedSections.deletedSectionIds != null) {
          this.changedSections.deletedSectionIds.forEach(element => {
            element.breadcrumb = this._breadcrumb(element.breadcrumbs);
          });
        }
        if (this.changedSections.updatedSectionIds != null) {
          this.changedSections.updatedSectionIds.forEach(element => {
            element.breadcrumb = this._breadcrumb(element.breadcrumbs);
          });
        }
      }
    }
  }

  _breadcrumb(breadcrumbs) {
    if (breadcrumbs != null) {
      return breadcrumbs.join(' -> ');
    }
  }

  getPolicyDocuments() {
    return _pmDataService.getPolicyDocuments().then(({ data }) => this._extractDocuments(data));
  }

  _extractDocuments(data) {
    let activeDocument = null;
    let completedDocuments = null;
    const docs = data && data.result;
    if (!docs || data.result.length === 0) {
      // There are no documents or no results
      return {
        activeDocument,
        completedDocuments,
      };
    }
    if (docs.length > 1) {
      // There is more than one document
      const partitionedDocuments = R.partition(R.propIs(String, 'approvedBy'), docs);
      if (partitionedDocuments.length > 1) {
        activeDocument = partitionedDocuments[1][0];
      }
      completedDocuments = partitionedDocuments[0];
    } else if (!docs[0].approvedBy) {
      // There is only one document and it is the active document
      activeDocument = docs[0];
    } else {
      // There is only one document and it is the completed document
      completedDocuments = docs;
    }
    return {
      activeDocument,
      completedDocuments,
    };
  }

  // #################################################################################################
  // SECTIONS

  /**
   *
   * @param {int} policyDocumentSectionId
   * @return {*}
   */
  getSection(policyDocumentSectionId) {
    return _pmDataService.getSection(policyDocumentSectionId).then(response => response.data);
  }

  saveSection(section, explanation) {
    if (section.policyDocumentSectionId > 0) {
      return _pmDataService.updateSection(section, explanation);
    }
    return _pmDataService.addSection(section, explanation);
  }

  replaceTokens(text) {
    // Match: Whole match on the regex
    // tokenType: Group 1 of the whole match (before the |)
    // tokenDisplay: Group 2 of the whole match (after the |)
    const regEx = new RegExp(/\$\[pm-([a-z]+)\|([a-zA-Z0-9_ -]+)\]\$/gm);
    return text.replace(regEx, (match, tokenType, tokenDisplay) => {
      if (tokenType === 'endnote') {
        return `<span class="rte-token pm-endnote">${tokenDisplay}</span>`;
      }
      return `<span class="rte-token pm-variable">${tokenDisplay.replace(/[_]/g, ' ')}</span>`;
    });
  }

  getCombinedChangesFromChangeArrays(changeArray) {
    let combinedNewRecommendedChanges = [];
    if (changeArray) {
      if (changeArray.addedMasterSectionIds && changeArray.addedMasterSectionIds.length > 0) {
        combinedNewRecommendedChanges = [...combinedNewRecommendedChanges, ...changeArray.addedMasterSectionIds];
      }
      if (changeArray.deletedSectionIds && changeArray.deletedSectionIds.length > 0) {
        combinedNewRecommendedChanges = [...combinedNewRecommendedChanges, ...changeArray.deletedSectionIds];
      }
      if (changeArray.updatedEndNoteIds && changeArray.updatedEndNoteIds.length > 0) {
        combinedNewRecommendedChanges = [...combinedNewRecommendedChanges, ...changeArray.updatedEndNoteIds];
      }
      if (changeArray.updatedSectionIds && changeArray.updatedSectionIds.length > 0) {
        combinedNewRecommendedChanges = [...combinedNewRecommendedChanges, ...changeArray.updatedSectionIds];
      }
      if (changeArray.createdMasterEndNoteIds && changeArray.createdMasterEndNoteIds.length > 0) {
        combinedNewRecommendedChanges = [...combinedNewRecommendedChanges, ...changeArray.createdMasterEndNoteIds];
      }
    }
    return combinedNewRecommendedChanges;
  }

  GetLatestMasterDocumentSection(masterDocumentSection) {
    let nextVersion = masterDocumentSection;

    if (masterDocumentSection.nextVersionId === null || masterDocumentSection.nextVersionId <= 0) {
      return masterDocumentSection;
    } else {
      nextVersion = R.find(
        R.propEq('masterDocumentSectionId', masterDocumentSection.nextVersionId),
        this.masterDocumentSections,
      );
    }

    return this.GetLatestMasterDocumentSection(nextVersion);
  }

  // #################################################################################################
  // VARIABLES

  /**
   *
   * @return {Promise<Array<variable>>}
   */
  getVariables() {
    return _pmDataService.getVariables().then(response => {
      const policyDocumentVariables = response.data.result;
      return transformations.transformPolicyDocumentVariablesToVariables(policyDocumentVariables);
    });
  }

  getEmptyVariables() {
    return _pmDataService.getEmptyVariables().then(response => {
      const policyDocumentVariables = response.data.result;
      return transformations.transformPolicyDocumentVariablesWithCategory(policyDocumentVariables);
    });
  }

  // #################################################################################################
  // ENDNOTES

  /**
   *
   * @param {int} policyDocumentId
   * @return {Promise<Array<endnote>>}
   */
  getEndnotes(policyDocumentId) {
    return _pmDataService.getEndnotes(policyDocumentId).then(response => {
      const policyDocumentEndNotes = response.data.result;
      const transformedEndNotes = transformations.transformPolicyDocumentEndNotesToEndnotes(policyDocumentEndNotes);
      return this.sort(transformedEndNotes, 'tag');
    });
  }

  getNewEndnote(policyDocumentId) {
    return transformations.getNewEndnote(policyDocumentId);
  }

  checkEndnoteTagExists(policyDocumentId, endNoteId, displayName) {
    // const tag = transformations.transformEndnoteDisplayNameToTag(tag);
    return _pmDataService
      .checkEndnoteTagExists(policyDocumentId, endNoteId, displayName)
      .then(response => response.data);
  }

  /**
   *
   * @param {policyDocumentEndNote} policyDocumentEndNote
   * @return {policyDocumentEndNote}
   */
  addEndnote(policyDocumentEndNote, explanation) {
    return _pmDataService.addEndnote(policyDocumentEndNote, explanation).then(response => response.data);
  }

  /**
   *
   * @param {policyDocumentEndNote} policyDocumentEndNote
   * @return {policyDocumentEndNote}
   */
  updateEndnote(policyDocumentEndNote, explanation) {
    return _pmDataService.updateEndnote(policyDocumentEndNote, explanation).then(response => response.data);
  }

  /**
   *
   * @param {endnote} endnote
   * @return {policyDocumentEndNote}
   */
  saveEndnote(endnote, explanation) {
    const policyDocumentEndNote = transformations.transformEndnoteToPolicyDocumentEndNote(endnote);
    if (policyDocumentEndNote.policyDocumentEndNoteId > 0) {
      return this.updateEndnote(policyDocumentEndNote, explanation);
    }
    return this.addEndnote(policyDocumentEndNote, explanation);
  }
}

pmSharedModelService.$inject = ['$q', 'pmDataService', 'orgDataService', 'utilityService'];

export default angular
  .module('app.services.pmSharedModelService', [pmDataService, orgDataService])
  .service('pmSharedModelService', pmSharedModelService).name;
